/* eslint-disable */
import React from 'react';
import MainCard from '../MainCard';
import { Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box, Grid } from '@mui/material';
import ListingAnalytics from './ListingAnalytics';
import EditIcon from '@mui/icons-material/Edit';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    bgcolor: 'background.paper',
    border: '1px solid #ddd',
    borderRadius: 4,
    boxShadow: 24,
    p: 4
};

export default function AnalyticsHistory({ historyRefresh, data, propertyId }) {
    const [open, setOpen] = React.useState(false);
    const [hitCounters, setHitCounters] = React.useState([]);

    const handleOpen = (e) => {
        setOpen(true);
        setHitCounters([e]);
    };
    const handleClose = () => setOpen(false);

    return (
        <MainCard title={'Analytics History'}>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <strong>Client Portals</strong>
                            </TableCell>
                            <TableCell>
                                <strong>Client Views</strong>
                            </TableCell>
                            <TableCell>
                                <strong>Client Favorites</strong>
                            </TableCell>
                            <TableCell>
                                <strong>Client Possibilities</strong>
                            </TableCell>
                            <TableCell>
                                <strong>Auto Emails</strong>
                            </TableCell>
                            <TableCell>
                                <strong>Prev 14 Day Views</strong>
                            </TableCell>
                            <TableCell>
                                <strong>Agent Published</strong>
                            </TableCell>
                            <TableCell>
                                <strong>Agent Views</strong>
                            </TableCell>
                            <TableCell>
                                <strong>Agent Rejected</strong>
                            </TableCell>
                            <TableCell>
                                <strong>Agent IDX</strong>
                            </TableCell>
                            <TableCell>
                                <strong>Date</strong>
                            </TableCell>
                            {/* <TableCell>
                                <strong>Action</strong>
                            </TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map((e, index) => (
                            <TableRow key={`analyticshistoryrow-${index}`}>
                                <TableCell>{e?.clientPortals || '0'}</TableCell>
                                <TableCell>{e?.clientViews || '0'}</TableCell>
                                <TableCell>{e?.clientFavorites || '0'}</TableCell>
                                <TableCell>{e?.clientPossibilities || '0'}</TableCell>
                                <TableCell>{e?.autoEmails || '0'}</TableCell>
                                <TableCell>{e?.prev14DayViews || '0'}</TableCell>
                                <TableCell>{e?.agentPublished || '0'}</TableCell>
                                <TableCell>{e?.agentViews || '0'}</TableCell>
                                <TableCell>{e?.agentRejected || '0'}</TableCell>
                                <TableCell>{e?.agentIDX || '0'}</TableCell>

                                <TableCell>
                                    {new Date(e?.startDate).toLocaleString('en-US', {
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })}
                                </TableCell>
                                <TableCell
                                    onClick={() => {
                                        handleOpen(e);
                                    }}
                                >
                                    <EditIcon color="primary" sx={{ fontSize: '1.2rem', mr: 1 }} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {data?.length <= 0 && (
                <Box sx={{ width: '100%', minHeight: '5rem', textAlign: 'center', verticalAlign: 'center' }}>
                    <Typography variant="h4" color="textSecondary" sx={{ mt: 4 }}>
                        No data available
                    </Typography>
                </Box>
            )}

            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <ListingAnalytics historyRefresh={historyRefresh} hitCounters={hitCounters} propertyId={propertyId} isEdited={true} />
                </Box>
            </Modal>
        </MainCard>
    );
}
